import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  IconButton,
} from "@mui/material";
import { CircularProgress, Tooltip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import RefreshIcon from "@mui/icons-material/Refresh";
import ApiEndpoints from "../../../network/ApiEndPoints";
import {
  get,
  postFormData,
  postJsonData,
} from "../../../network/ApiController";
import { apiErrorToast } from "../../../utils/ToastUtil";
import CachedIcon from "@mui/icons-material/Cached";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { set } from "date-fns";
import Autocomplete from "@mui/material/Autocomplete";

import { predefinedRanges } from "../../../utils/constants";
import { DateRangePicker } from "rsuite";

const DataFilter = ({
  handleRefresh,
  setQuary,
  query,
  queryParam,
  ifStatusFilter = false,
  ifNameFilter = false,
  ifIdFilter = false,
  ifMobileFilter = false,
  ifRoleFilter = false,
  ifCategoryFilter = false,
  ifUsernameFilter = false,
  ifNumberFilter = false,
  ifDateFilter = false,
  ifDateRangeFilter = false,
  ifstatusFilter3 = false,
  ifProjectNameFilter = false,
  ifPriorityFilter = false,
  ifAssignedToFilter = false,
  ifCreatedByFilter = false,
  ifemployeeFilter = false,
  unassigned = false,
  ifipFilter = false,
  ifUseridFilter = false,
  ifPunishmentTypeFilter = false,
onReset
}) => {
  // Separate states for each filter
  const [taskStatusVal, setTaskStatusVal] = useState("");
  const [taskStatusOptions, setTaskStatusOptions] = useState([]);
  const [status, setStatus] = useState("");
  const [category, setCategory] = useState("");
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const [mobile, setMobile] = useState("");
  const [role, setRole] = useState("");
  const [username, setUsername] = useState("");
  const [number, setNumber] = useState("");
  const [date, setDate] = useState("");
  const [dateRange, setDateRange] = useState({
    dateVal: null,
    start: "",
    end: "",
  });
  const [filterUsers, setFilterUsers] = useState([]);
  const [priority, setPriority] = useState("");
  const [selectedProject, setSelectedProject] = useState("");
  const [projectname, setProjectName] = useState([]);
  const [categoryName, setCategoryName] = useState([]);
  const [isResetClicked, setIsResetClicked] = useState(false);
  const [request, setRequest] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [users, setusers] = useState([]);
  const [createdBy, setCreatedBy] = useState("");
  const [ip, setIp] = useState("");
  const [userId, setUserId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [employee, setEmployee] = useState([]);
  const [punishmentType, setPunishmentType] = useState("");

  const [loadingProjects, setLoadingProjects] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(false);

  const hasActiveFilters =
    ifStatusFilter ||
    ifNameFilter ||
    ifIdFilter ||
    ifMobileFilter ||
    ifRoleFilter ||
    ifCategoryFilter ||
    ifUsernameFilter ||
    ifNumberFilter ||
    ifDateFilter ||
    ifDateRangeFilter ||
    ifstatusFilter3 ||
    ifProjectNameFilter ||
    ifPriorityFilter ||
    ifAssignedToFilter ||
    ifCreatedByFilter ||
    ifemployeeFilter ||
    ifipFilter ||
    ifUseridFilter;

  const getBaseParams = () => {
    const baseParams = new URLSearchParams();

    if (queryParam?.includes("status=unassigned")) {
      baseParams.set("status", "unassigned");
    }

    // const assignedMatch = queryParam?.match(/assigned_to=\d+/);
    // if (assignedMatch) {
    //   baseParams.set("assigned_to", assignedMatch[0].split("=")[1]);
    // }

    return baseParams;
  };

  const yyyymmdd = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };

  const afterToday = () => {
    return (date) => {
      if (!date) return false;
      return date > new Date();
    };
  };

  const getProject = () => {
    setLoadingProjects(true);
    get(
      ApiEndpoints.GET_PROJECT_NAME,
      "",
      setRequest,
      (res) => {
        setProjectName(res.data || []);
        setLoadingProjects(false);
      },
      (error) => {
        console.error("API Error:", error);
        apiErrorToast(error);
        setLoadingProjects(false);
      }
    );
  };

  const getCategory = () => {
    setLoadingCategories(true);
    get(
      `${ApiEndpoints.GET_UTILS}?type=category`,
      "",
      setRequest,
      (res) => {
        if (res.data && res.data.data) {
          setCategoryName(res.data.data);
        }
        setLoadingCategories(false);
      },
      (error) => {
        console.error("API Error:", error);
        apiErrorToast(error);
        setLoadingCategories(false);
      }
    );
  };

  const getUsers = () => {
    setLoadingUsers(true);
    postJsonData(
      `${ApiEndpoints.GET_USERS_NAME}`,
      { role: "ALL" },
      setRequest,
      (res) => {
        if (res.data) {
          setusers(res.data || []);
        }
        setLoadingUsers(false);
      },
      (error) => {
        console.error("API Error:", error);
        apiErrorToast(error);
        setLoadingUsers(false);
      }
    );
  };

  const getTaskStatuses = () => {
    get(
      `${ApiEndpoints.GET_UTILS}?type=TaskStatus`,
      "",
      setRequest,
      (res) => {
        if (res.data && res.data.data) {
          setTaskStatusOptions(res.data.data);
        }
      },
      (error) => {
        console.error("API Error:", error);
        apiErrorToast(error);
      }
    );
  };

  const getEmployee = () => {
    setLoadingEmployees(true);
    postFormData(
      `${ApiEndpoints.GET_USERS_NAME}`,
      { role: "EMPLOYEE" },
      setRequest,
      (res) => {
        if (res.data) {
          setEmployee(res.data || []);
        }
        setLoadingEmployees(false);
      },
      (error) => {
        console.error("API Error:", error);
        apiErrorToast(error);
        setLoadingEmployees(false);
      }
    );
  };

  useEffect(() => {
    getTaskStatuses();
  }, []);

  useEffect(() => {
    if (ifCategoryFilter) getCategory();
    if (ifProjectNameFilter) getProject();
    if (ifemployeeFilter) getEmployee();

    if (ifAssignedToFilter || ifCreatedByFilter || ifIdFilter) {
      getUsers();
    }
  }, [
    ifCategoryFilter,
    ifProjectNameFilter,
    ifemployeeFilter,
    ifAssignedToFilter,
    ifCreatedByFilter,
    ifIdFilter,
  ]);

  const handleApply = () => {
    const queryParams = getBaseParams();

    if (status) queryParams.set("status", status);
    if (category) queryParams.set("category", category);
    if (name) queryParams.set("name", name);
    if (id) queryParams.set("id", id);
    if (mobile) queryParams.set("mobile", mobile);
    if (role) queryParams.set("role", role);
    if (username) queryParams.set("username", username);
    if (number) queryParams.set("number", number);
    if (date) queryParams.set("date", date);
    if (dateRange.start && dateRange.end) {
      queryParams.set("start_date", dateRange.start);
      queryParams.set("end_date", dateRange.end);
    }
    if (selectedProject) queryParams.set("project_name", selectedProject);
    if (priority) queryParams.set("priority", priority);
    if (assignedTo) queryParams.set("assigned_to", assignedTo);
    if (createdBy) queryParams.set("created_by", createdBy);
    if (ip) queryParams.set("ip", ip);
    if (userId) queryParams.set("user_id", userId);
    if (taskStatusVal) queryParams.set("status", taskStatusVal);
    if (employeeName) queryParams.set("user_name", employeeName);
    if (punishmentType) queryParams.set("status", punishmentType);

    setQuary(queryParams.toString());
    setIsResetClicked(false);
  };

  const handleReset = () => {
    setStatus("");
    setTaskStatusVal("");
    setCategory("");
    setName("");
    setId("");
    setMobile("");
    setRole("");
    setUsername("");
    setNumber("");
    setDate("");
    setDateRange({ dateVal: null, start: "", end: "" });
    setSelectedProject("");
    setPriority("");
    setAssignedTo("");
    setCreatedBy("");
    setIp("");
    setUserId("");
    setEmployeeName("");
    setPunishmentType("");

    // Force a re-render by resetting the states to their initial values
    const baseParams = getBaseParams();
    setQuary(baseParams.toString());
    setIsResetClicked(true);
    
    // Force a small delay to ensure state updates
    setTimeout(() => {
      // This ensures the Autocomplete components re-evaluate their values
      setusers([...users]); // Trigger re-render of users array
    }, 0);

      if (onReset) {
    onReset();
  }
  };

  // Status options for ifStatusFilter
  const statusOptions = [
    { value: "Open", label: "Open" },
    { value: "In Progress", label: "In Progress" },
    { value: "Completed", label: "Completed" },
  ];

  // Priority options
  const priorityOptions = [
    { value: "High", label: "High" },
    { value: "Medium", label: "Medium" },
    { value: "Low", label: "Low" },
  ];

  // Punishment type options
  const punishmentTypeOptions = [
    { value: "", label: "All" },
    { value: "added", label: "Added" },
    { value: "deduct", label: "Deduct" },
  ];

  return (
    <Box
      padding={0.4}
      display="flex"
      flexWrap="wrap"
      gap={1}
      alignItems="center"
    >
      {/* Status Filter with Autocomplete */}
      {ifStatusFilter && (
        <Autocomplete
          size="small"
          style={{ minWidth: 150 }}
          options={statusOptions}
          getOptionLabel={(option) => option.label}
          value={statusOptions.find((opt) => opt.value === status) || null}
          onChange={(event, newValue) => {
            setStatus(newValue?.value || "");
          }}
          renderInput={(params) => (
            <TextField {...params} label="Status" variant="outlined" />
          )}
          renderOption={(props, option) => (
            <MenuItem {...props}>{option.label}</MenuItem>
          )}
          isOptionEqualToValue={(option, value) =>
            option.value === value?.value
          }
        />
      )}

      {/* Category Filter with Autocomplete */}
      {ifCategoryFilter && (
        <Autocomplete
          size="small"
          style={{ minWidth: 150 }}
          options={categoryName || []}
          getOptionLabel={(option) => option.name || ""}
          value={categoryName.find((cat) => cat.name === category) || null}
          onChange={(event, newValue) => {
            setCategory(newValue?.name || "");
          }}
          loading={loadingCategories}
          loadingText="Loading categories..."
          noOptionsText="No categories found"
          renderInput={(params) => (
            <TextField {...params} label="Category" variant="outlined" />
          )}
          renderOption={(props, option) => (
            <MenuItem {...props}>{option.name}</MenuItem>
          )}
          isOptionEqualToValue={(option, value) => option.name === value?.name}
        />
      )}

      {/* ID Filter (User) with Autocomplete */}
      {ifIdFilter && (
        <Autocomplete
          size="small"
          style={{ minWidth: 150 }}
          options={users || []}
          getOptionLabel={(option) => option.name || ""}
          value={users.find((user) => String(user?.id) === String(id)) || null}
          onChange={(event, newValue) => {
            setId(newValue?.id || "");
          }}
          loading={loadingUsers}
          loadingText="Loading users..."
          noOptionsText="No users found"
          renderInput={(params) => (
            <TextField
              {...params}
              label="User"
              variant="outlined"
              placeholder="Search user..."
            />
          )}
          renderOption={(props, option) => (
            <MenuItem {...props}>{option.name}</MenuItem>
          )}
          isOptionEqualToValue={(option, value) => 
            String(option?.id) === String(value?.id)
          }
        />
      )}

      {/* Name Filter (Text Input) */}
      {ifNameFilter && (
        <TextField
          name="name"
          label="Name"
          variant="outlined"
          size="small"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ minWidth: 150 }}
        />
      )}

      {/* Mobile Filter (Text Input) */}
      {ifMobileFilter && (
        <TextField
          name="mobile"
          label="Mobile"
          variant="outlined"
          size="small"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          style={{ minWidth: 150 }}
        />
      )}

      {/* Role Filter (Text Input) */}
      {ifRoleFilter && (
        <TextField
          name="role"
          label="Role"
          variant="outlined"
          size="small"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          style={{ minWidth: 150 }}
        />
      )}

      {/* Date Range Filter */}
      {ifDateRangeFilter && (
        <div
          style={{
            overflow: "hidden",
            marginBottom: "0.4%",
          }}
          className="mx-2"
        >
          <FormControl className="filter-date">
            <DateRangePicker
              size="md"
              editable
              ranges={predefinedRanges}
              cleanable
              showOneCalendar
              appearance="subtle"
              placeholder="Date"
              value={dateRange.dateVal}
              onChange={(value) => {
                if (value) {
                  setDateRange({
                    dateVal: value,
                    start: yyyymmdd(value[0]),
                    end: yyyymmdd(value[1]),
                  });
                } else {
                  setDateRange({ dateVal: null, start: "", end: "" });
                }
              }}
              disabledDate={afterToday()}
              placement="bottomStart"
              container={document.body}
              style={{ zIndex: 1 }}
            />
          </FormControl>
        </div>
      )}

      {/* Task Status Filter with Autocomplete */}
      {ifstatusFilter3 && (
        <Autocomplete
          size="small"
          style={{ minWidth: 150 }}
          options={taskStatusOptions || []}
          getOptionLabel={(option) => option.name || ""}
          value={
            taskStatusOptions.find((status) => status.name === taskStatusVal) ||
            null
          }
          onChange={(event, newValue) => {
            setTaskStatusVal(newValue?.name || "");
          }}
          renderInput={(params) => (
            <TextField {...params} label="Status" variant="outlined" />
          )}
          renderOption={(props, option) => (
            <MenuItem {...props}>{option.name}</MenuItem>
          )}
          isOptionEqualToValue={(option, value) => option.name === value?.name}
        />
      )}

      {/* Username Filter (Text Input) */}
      {ifUsernameFilter && (
        <TextField
          name="username"
          label="Username"
          variant="outlined"
          size="small"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{ minWidth: 150 }}
        />
      )}

      {/* Number Filter (Text Input) */}
      {ifNumberFilter && (
        <TextField
          name="number"
          label="Number"
          variant="outlined"
          size="small"
          value={number}
          onChange={(e) => setNumber(e.target.value)}
          style={{ minWidth: 150 }}
        />
      )}

      {/* Date Filter */}
      {ifDateFilter && (
        <TextField
          name="date"
          type="date"
          variant="outlined"
          size="small"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          style={{ minWidth: 150 }}
        />
      )}

      {/* Project Name Filter with Autocomplete */}
      {ifProjectNameFilter && (
        <Autocomplete
          size="small"
          style={{ minWidth: 150 }}
          options={projectname || []}
          getOptionLabel={(option) => option.name || ""}
          value={
            projectname.find((project) => project.name === selectedProject) ||
            null
          }
          onChange={(event, newValue) => {
            setSelectedProject(newValue?.name || "");
          }}
          loading={loadingProjects}
          loadingText="Loading projects..."
          noOptionsText="No projects found"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Project Name"
              variant="outlined"
              placeholder="Search project..."
            />
          )}
          renderOption={(props, option) => (
            <MenuItem {...props}>{option.name}</MenuItem>
          )}
          isOptionEqualToValue={(option, value) => option.name === value?.name}
        />
      )}

      {/* Priority Filter with Autocomplete */}
      {ifPriorityFilter && (
        <Autocomplete
          size="small"
          style={{ minWidth: 150 }}
          options={priorityOptions}
          getOptionLabel={(option) => option.label}
          value={priorityOptions.find((opt) => opt.value === priority) || null}
          onChange={(event, newValue) => {
            setPriority(newValue?.value || "");
          }}
          renderInput={(params) => (
            <TextField {...params} label="Priority" variant="outlined" />
          )}
          renderOption={(props, option) => (
            <MenuItem {...props}>{option.label}</MenuItem>
          )}
          isOptionEqualToValue={(option, value) =>
            option.value === value?.value
          }
        />
      )}

      {/* Assigned To Filter with Autocomplete - FIXED */}
      {ifAssignedToFilter && (
        <Autocomplete
          size="small"
          style={{ minWidth: 150 }}
          options={users || []}
          getOptionLabel={(option) => option.name || ""}
          value={users?.find((user) => String(user?.id) === String(assignedTo)) || null}
          onChange={(event, newValue) => {
            setAssignedTo(newValue?.id || "");
          }}
          loading={loadingUsers}
          loadingText="Loading users..."
          noOptionsText="No users found"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Assigned To"
              variant="outlined"
              placeholder="Search user..."
            />
          )}
          renderOption={(props, option) => (
            <MenuItem {...props}>{option.name}</MenuItem>
          )}
          isOptionEqualToValue={(option, value) => 
            String(option?.id) === String(value?.id)
          }
          key={`assigned-to-${assignedTo}-${users.length}`} // Add key to force re-render on reset
        />
      )}

      {/* Created By Filter with Autocomplete - FIXED */}
      {ifCreatedByFilter && (
        <Autocomplete
          size="small"
          style={{ minWidth: 150 }}
          options={users || []}
          getOptionLabel={(option) => option.name || ""}
          value={users.find((user) => String(user?.id) === String(createdBy)) || null}
          onChange={(event, newValue) => {
            setCreatedBy(newValue?.id || "");
          }}
          loading={loadingUsers}
          loadingText="Loading users..."
          noOptionsText="No users found"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Created By"
              variant="outlined"
              placeholder="Search user..."
            />
          )}
          renderOption={(props, option) => (
            <MenuItem {...props}>{option.name}</MenuItem>
          )}
          isOptionEqualToValue={(option, value) => 
            String(option?.id) === String(value?.id)
          }
          key={`created-by-${createdBy}-${users.length}`} // Add key to force re-render on reset
        />
      )}

      {/* IP Filter (Text Input) */}
      {ifipFilter && (
        <TextField
          name="ip"
          label="IP Address"
          variant="outlined"
          size="small"
          value={ip}
          onChange={(e) => setIp(e.target.value)}
          style={{ minWidth: 150 }}
        />
      )}

      {/* User ID Filter (Text Input) */}
      {ifUseridFilter && (
        <TextField
          name="userId"
          label="User ID"
          variant="outlined"
          size="small"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          style={{ minWidth: 150 }}
        />
      )}

      {/* Employee Filter with Autocomplete */}
      {ifemployeeFilter && (
        <Autocomplete
          size="small"
          style={{ minWidth: 150 }}
          options={employee || []}
          getOptionLabel={(option) => option.name || ""}
          value={employee.find((emp) => emp.name === employeeName) || null}
          onChange={(event, newValue) => {
            setEmployeeName(newValue?.name || "");
          }}
          loading={loadingEmployees}
          loadingText="Loading employees..."
          noOptionsText="No employees found"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Employee Name"
              variant="outlined"
              placeholder="Search employee..."
            />
          )}
          renderOption={(props, option) => (
            <MenuItem {...props}>{option.name}</MenuItem>
          )}
          isOptionEqualToValue={(option, value) => option.name === value?.name}
        />
      )}

      {/* Punishment Type Filter with Autocomplete */}
      {ifPunishmentTypeFilter && (
        <Autocomplete
          size="small"
          style={{ minWidth: 150 }}
          options={punishmentTypeOptions}
          getOptionLabel={(option) => option.label}
          value={
            punishmentTypeOptions.find((opt) => opt.value === punishmentType) ||
            null
          }
          onChange={(event, newValue) => {
            setPunishmentType(newValue?.value || "");
          }}
          renderInput={(params) => (
            <TextField {...params} label="Type" variant="outlined" />
          )}
          renderOption={(props, option) => (
            <MenuItem {...props}>{option.label}</MenuItem>
          )}
          isOptionEqualToValue={(option, value) =>
            option.value === value?.value
          }
        />
      )}

      {/* Action Buttons */}
      {hasActiveFilters && (
        <>
          <Button
            variant="contained"
            color="primary"
            startIcon={<CheckIcon />}
            onClick={handleApply}
            size="small"
          >
            Apply
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            startIcon={<ClearIcon />}
            onClick={handleReset}
            size="small"
          >
            Reset
          </Button>
        </>
      )}

      {/* Refresh Button */}
      {handleRefresh && (
        <Box display="flex" gap={1}>
          <IconButton
            color="primary"
            onClick={() => handleRefresh(setQuary)}
            size="small"
          >
            <CachedIcon sx={{ color: "#0F52BA" }} />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default DataFilter;